import { App } from "vue";

export const setupFormily = (app: App<Element>, fields: Record<string, any>) => {
  Object.keys(fields).forEach((key) => {
    app.component(key, (fields as any)[key]);
  });
};
